jQuery(function ($) {
    $(window).on("click", function () {
      $('#menu-visitors-main-menu .active').removeClass('active');
    });
  
    $('#menu-visitors-main-menu').on("click", function (event) {
      event.stopPropagation();
    });
  
    $('#menu-visitors-main-menu .active').removeClass('active');
  
    $('#menu-visitors-main-menu .submenu .stacked .largeimage').each(function () {
      const parent = $(this).parent('stacked').parent('ul');
      const dup = $(this).clone();
      $(this).parent('.stacked').after(dup);
      $(this).remove();
    });
  
    $(window)
      .on('resize', function () {
        $('#menu-visitors-main-menu .active').removeClass('active');
  
        if ($(window).width() > 991) {
          $('.panel-close').closest('li').remove();
          $('#menu-visitors-main-menu .submenu').removeClass('submenu-open submenu-animate submenu-close');
          $('.largeimage').removeClass('hide');
  
          $('#menu-visitors-main-menu .menu-item-has-children .top-level')
            .off('click')
            .on('click', function (event) {
              event.preventDefault();
              $(this).toggleClass('active');
              $(this).siblings('ul').toggleClass('active');
              $(this).parent('li').siblings().find('.second-level').removeClass('active');
              $(this).parent('li').siblings().find('.submenu').removeClass('submenu-open submenu-animate submenu-close');
              $(this).parent('li').siblings().find('.top-level, .megamenu, .removelink').removeClass('active hide');
            });
  
          $('#menu-visitors-main-menu .menu-item-has-children > .second-level')
            .off('click')
            .on('click', function (event) {
              event.preventDefault();
              $(this).toggleClass('active');
              $(this).siblings('.submenu').first().toggleClass('submenu-open submenu-animate').removeClass('submenu-close');
              $(this).parents('.stacked').parent('ul').find('.largeimage').toggleClass('hide');
              $(this).parent('li').siblings().find('.second-level').removeClass('active');
              $(this).parent('li').siblings().find('.submenu').removeClass('submenu-open submenu-animate submenu-close');
            });
  
        } else {
          $('.menu-item-has-children').removeClass('active');
          $('.megamenu').removeClass('active submenu-open submenu-animate submenu-close');
  
          $('.menu-item-has-children > a')
            .off('click')
            .on('click', function (event) {
              event.preventDefault();
              $(this).parent('.menu-item-has-children').find('.submenu').first()
                .addClass('submenu-open submenu-animate')
                .removeClass('submenu-close');
            });
  
          $('#menu-visitors-main-menu a.third-level').each(function () {
            $(this).parent('li').addClass('label');
          });
  
          $('#menu-visitors-main-menu #menu-item-580 a.third-level')
            .off('click')
            .on('click', function (event) {
              return true;
            });
  
          if ($('.panel-close').length === 0) {
            $("<li><a class='panel-close' href='#'>Back</a></li>").prependTo('.submenu');
          }
  
          $('.panel-close').on("click", function () {
            $(this).closest('.submenu').first()
              .removeClass('submenu-open')
              .addClass('submenu-close submenu-animate');
          });
        }
      })
      .trigger('resize');
  });
  